export const STRUCTURED_DATA_TYPES = {
  JSON_ONLY: 'JSON_ONLY',
  HTML_ONLY: 'HTML_ONLY',
  JSON_AND_HTML: 'JSON_AND_HTML',
}
